import React, { useEffect } from 'react';

const InRoomDiningAddonViewDetail = ({ addon }) => {
  useEffect(() => {}, [addon]);

  return (
    <div className='row mx-4 mt-4'>
      {
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Addon Name</div>
            <div className='details-value preview-breaks'>{addon.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label text-center'>Status</div>
            <div
              className={`${
                addon.status ? 'pill-active' : 'pill-inactive'
              } col-md-3 pill-text pill container`}
            >
              <span>{addon.status ? 'Active' : 'Inactive'}</span>
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Addon Code</div>
            <div className='details-value'>{addon.code}</div>
          </div>
          {addon?.customAttributes &&
            addon?.customAttributes?.length > 0 &&
            addon?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </>
      }
    </div>
  );
};

export default InRoomDiningAddonViewDetail;
